export const environment = {
  production: false,
  apiName: 'https://borracce-test.realaxiom.com',
  s3PublicBucket: 'com.elite.realvideo.test',
  turnstileSiteKey: '0x4AAAAAAEbdTKBt_Ofrpw-K'
};
